import Image from 'components/shared/image';
import { getCurrencySymbol } from 'lib/shopify';
import styles from './orderItem.module.scss';

const OrderItem = ({ orderItem, quantityField, locale }) => (
  <div className={styles.orderItem}>
    {orderItem?.variant?.image && (
      <Image src={orderItem?.variant?.image} layout="fill" className={styles.image} />
    )}
    <div className={styles.info}>
      <div className={styles.subContainer}>
        <h3 className={styles.orderTitle}>{orderItem.title}</h3>
        {orderItem?.variant && (
          <span className={styles.orderPrice}>
            {getCurrencySymbol(locale)}{' '}
            {orderItem.variant.priceV2.amount}
          </span>
        )}
      </div>
      <div className={styles.quantityContainer}>
        <span className={styles.orderQuantity}>
          {quantityField?.text}: {orderItem.quantity}
        </span>
      </div>
    </div>
  </div>
);

export default OrderItem;
